export default {
  setSelections(state, val) {
    state.selections = val.selections
  },
}



// WEBPACK FOOTER //
// ./src/Osm/Renewal/store/mutations.js